import React, { FunctionComponent } from "react";
import { IIconProps } from "../icon";

export const AnimalBasedIcon: FunctionComponent<IIconProps> = (props) => {
  const { color } = props;
  return (
    <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600" fill={color}>
      <defs>
        <style
          dangerouslySetInnerHTML={{
            __html: `.cls-animal-1,.cls-animal-2,.cls-animal-3{fill:none;stroke:${color};stroke-miterlimit:10;}.cls-animal-1{stroke-width:20px;}.cls-animal-2{stroke-width:15px;}.cls-animal-3{stroke-width:17px;}`,
          }}
        />
      </defs>
      <path
        className="cls-animal-1"
        d="M119.41,197.13c8.83-16.1,42.63-94,171-111.63,11.73-1.61,122.42-11.14,174,56.34,25.78,33.71,49.82,81.62,26.26,137.07C462.27,345.86,379.19,322,323.66,389.72c-31.51,38.42-7,80.92-44.62,112-5.12,4.23-50.73,24.22-85.27,13.16C130.48,494.67,53.59,317,119.41,197.13Z"
      />
      <circle className="cls-animal-2" cx="390.77" cy="230.6" r="28.75" />
      <path
        className="cls-animal-3"
        d="M173.94,209.83c-10.28-33,47.7-88.46,129.91-91.67,13.26-.52,76.71-3,121.25,44.26,8.08,8.58,47.67,51.36,31.76,96.47-16.93,48-134.27,84.6-156.73,38.75C257.81,211.24,188.37,256.21,173.94,209.83Z"
      />
      <path
        className="cls-animal-3"
        d="M158.93,260.59c23.75-14.2,72.16,19.26,97.31,69.54,5.79,11.58,35.43,70.86,7.05,111.23-10.9,15.51-33.11,32.14-54,28.23C147.86,458.11,120.39,283.64,158.93,260.59Z"
      />
    </svg>
  );
};
